<template>
  <div class="act-13-banner-ad-wrap"> 
    <list-style-1 ref="refNewsList"></list-style-1>
  </div>
</template>

<script>
  import ListStyle1 from '@/components/list/ListStyle1'

  export default {
    name: 'Act4Newslist',
    components: {
      'list-style-1': ListStyle1,
	    },
    data() {
      return {   
        type:0,     
      }
    }, 
    destroyed(){
    },
    mounted() {
      this.type = parseInt( this.$route.query.type )
      if(this.type && this.type > 0 ){
        this.removeLoader()      
        let cid = this.$route.query.style  
        let idArray = this.$route.query.idArray        
        this.$refs.refNewsList.getInid(cid,19,idArray)
        let title = "广西文化旅游发展大会"
        switch(this.type){
          case 1:
            title =  "广西文化旅游发展大会"
          break;          
        }
        //页面设置
        this.setDocumentV2(
          title, 
          "广西文化旅游发展大会",
          "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/static/img/act/20/share.jpg"
        );
        _czc.push(['_trackEvent', '广西文化旅游发展大会', '点击', title,this.type,'20']);
      } 
      

    },
    created() {      
    },
    methods: {
      displayArticle(id,type){
        this.$router.push('/act4/main/news?id=' + id)
      }
    }
  }
</script>

<style scoped>
.act-13-banner-ad-wrap{
  font-size: 0;
}
.act-10-banner-ad{
  width: 100%;
  margin-top: 10px;
  font-size: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/act/20/NewsList.vue